import { Suspense, lazy, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row } from "react-bootstrap";
// import EditBusinessTypeModal from "../../Components/Modals/EditBusinessTypeModal.js";
import _ from "lodash";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import DetailRow from "../../Components/CustomComponents/DetailRow.js";

const ZoomImage = lazy(() => import("../../Components/ZoomImage.js"));

const OrderDetailScreen = ({ setPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { orderData } = useLocation().state || {};
  console.log(orderData);

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  // MARK: Dummy Data

  useEffect(() => {
    if (orderData) {
      setRowData(orderData);
    }
  }, [orderData]);

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const expandRow = {
    className: "expanded",
    renderer: (row) => {
      console.log(row);
      return (
        <div
          key={_.uniqueId("prefix")}
          className="d-flex align-items-top gap-3 p-3"
        >
          <div className="d-flex justify-content-start align-items-center gap-2 flex-wrap w-50">
            {row.item_product?.product_attachments.map((attachment, i) => {
              return (
                <Suspense fallback={<div>Loading image...</div>}>
                  <ZoomImage
                    imageUrl={attachment?.media_url}
                    key={`attachment-${i}`}
                  />
                </Suspense>
              );
            })}
          </div>
          <table className="w-50 ms-auto" style={{ height: "fit-content" }}>
            <thead>
              <tr>
                <th>Variant Name</th>
                <th>Value</th>
                <th>Adjustable Price</th>
              </tr>
            </thead>
            <tbody>
              {row?.order_item_variants?.map((variant, index) => (
                <tr key={index}>
                  <td>{variant?.name}</td>
                  <td>{variant?.value}</td>
                  <td className="text-center">
                    {variant?.price ? `$ ${variant?.price}` : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    },

    onlyOneExpanding: true,
    parentClassName: "expandedRow",

    onExpand: (row, isExpand, rowIndex, e) => {
      console.log(row, isExpand, rowIndex, e);
      setTimeout(() => {
        // handlePatientData(row, isExpand);
      }, 500);
    },
  };

  const columns = [
    {
      dataField: "",
      text: "Image",
      headerAlign: "center",
      align: "center",
      // sort: true,
      headerStyle: {
        // width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row.item_product?.product_attachments[0]?.media_url);
        return (
          <Suspense fallback={<div>Loading image...</div>}>
            <ZoomImage
              imageUrl={row.item_product?.product_attachments[0]?.media_url}
            />
          </Suspense>
        );
      },
    },
    {
      dataField: "item_product.name",
      text: "Product Name",
      headerAlign: "center",
      align: "center",
      // sort: true,
      headerStyle: {
        // width: "100px",
      },
      formatter: (cellContent, row) => {
        return <span>{row?.item_product?.name}</span>;
      },
    },
    {
      dataField: "quantity",
      text: "Quantity",
      headerAlign: "center",
      align: "center",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "price",
      text: "Item Price",
      headerAlign: "center",
      align: "center",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div className="d-flex align-items-center gap-2">
              <span
                role="button"
                title="Go Back"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
              >
                <IoArrowBackCircleSharp size={30} />
              </span>
              <SubTitle text={"Order Details"} classes="text-black" />
            </div>
          </Col>
        </Row>
      </div>

      {orderData ? (
        <div className={styles.mainTable} style={{ cursor: "pointer" }}>
          {
            <Table
              // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
              data={orderData.items || []}
              columns={columns}
              indication={indication}
              // totalRecords={totalRecords} // todo
              // totalPages={totalPages} // todo
              // pageSize={pageSize} // todo
              // currentPage={currentPage} // todo
              // setCurrentPage={setCurrentPage} // todo
              // setPageSize={setPageSize} // todo
              // refetch={refetch} // todo
              // refetch={() => {}} // todo
              pagination={false} // todo
              expandRow={expandRow}
            />
          }
        </div>
      ) : (
        ""
      )}

      {orderData && (
        <Row className="w-100" id="row-2">
          <Col md={6} sm={12} id="col-1">
            {/* <div className="text-center">
                <img
                  style={{ aspectRatio: 1 }}
                  alt=""
                  src={editData?.image_url}
                  className="rounded-circle mb-3"
                  width={"100px"}
                />
              </div> */}
            <DetailRow
              title={"Name"}
              value={`${orderData?.user?.firstname} ${orderData?.user?.lastname}`}
            />
            <DetailRow title={"Email"} value={orderData?.user?.email} />
            <DetailRow title={"Phone"} value={orderData?.user?.mobile_no} />
            <DetailRow title={"Address"} value={orderData?.location} />
          </Col>

          <Col md={6} sm={12} id="col-1">
            <DetailRow
              title={"Sub Total"}
              value={`$ ${orderData?.sub_total}`}
            />
            <DetailRow
              title={"Delivery Charges"}
              value={`$ ${orderData?.delivery_charges}`}
            />
            <DetailRow
              title={"Platform Fee"}
              value={`$ ${orderData?.platform_fee}`}
            />
            <DetailRow
              title={"Total Amount"}
              value={`$ ${orderData?.total_amount}`}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default OrderDetailScreen;
